export const thousandsSeparator = (
    value: number | string | undefined,
): string => {
    if (typeof value !== 'number' && typeof value !== 'string') {
        return '---'
    }

    value = value?.toString()

    return value.length
        ? value?.replace(/(?<!\.\d*)(?<=\d)(?=(\d{3})+(?!\d))/g, ',')
        : '---'
}
